import { render, staticRenderFns } from "./TPoliciesAdd.vue?vue&type=template&id=665f1ae0&"
import script from "./TPoliciesAdd.vue?vue&type=script&lang=js&"
export * from "./TPoliciesAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports